import { createApp } from 'vue';
import googleMapStaticComponent from '@components-molecules/GoogleMapStatic.vue';

/**
 * Init google map vue component
 */
export const googleMapStatic = (el) => {
  const component = {
    delimiters: [ '${', '}' ],
    components: {
      'google-map-static': googleMapStaticComponent,
    },
    data() {
      return {
        isGoogleMapModalOpened: false,
      };
    },
    methods: {
      /**
       * This method displays the modal.
       */
      showGoogleMapModal() {
        this.isGoogleMapModalOpened = true;
      },
      /**
       * This method closes the modal.
       */
      closeGoogleMapModal() {
        this.isGoogleMapModalOpened = false;
      },
    },
  };

  return createApp(component).mount(el);
};
